import { Box, Typography } from "@mui/material";

const ReleaseNote1 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 1.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing the new 1449 and 892 Downloader in JUNE, designed to simplify and accelerate IDS preparation.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>
        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "12px" }}>
            <Typography variant="body2">
              <strong>1449 and 892 Downloader</strong>
              <span
                style={{
                  color: "green",
                  fontWeight: "bold",
                  fontSize: "0.75em",
                  verticalAlign: "super",
                }}
              >
                New!
              </span> : Easily download all 1449 (applicant-cited) and 892 (examiner-cited) references linked to one or multiple U.S. application numbers. The tool fetches all documents in one go and organizes them by mailing date for efficient review.
              <br></br>
              <br></br>
              <span>Refer to the FAQ and Tutorial sections for more details on this feature.</span>
            </Typography>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default ReleaseNote1;